export default __webpack_public_path__ + "static/media/order1.eae30973.png";